// extracted by mini-css-extract-plugin
export default {"parent":"addtask_parent__8FKWi","boxInput":"addtask_boxInput__DG3xN","boxFooter":"addtask_boxFooter__u1yda","addButton":"addtask_addButton__JTnxf","item":"addtask_item__mCPP5"};